import type { DealForecastAction, DealForecastState } from '@openx/types/store/deal.ts';
import { dealForecastReducer, initialDealForecastState } from '@openx/utils/lib/dealForecastReducer.ts';
import { createContext, type Dispatch, type PropsWithChildren, useContext, useReducer } from 'react';

type ForecastContextProps = {
  state: DealForecastState;
  dispatch: Dispatch<DealForecastAction>;
};

const forecastContext = createContext<ForecastContextProps>({
  dispatch: () => {
    throw new Error('Forgot to wrap component in ForecastContext.Provider');
  },
  state: {},
});

export const DealForecastProvider = ({ children }: PropsWithChildren) => {
  const [state, dispatch] = useReducer(dealForecastReducer, initialDealForecastState);

  return <forecastContext.Provider value={{ dispatch, state }}>{children}</forecastContext.Provider>;
};

export const useDealForecastStore = () => useContext(forecastContext);
